var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass:
        "yxtbiz-multi-class-audit font-size-16 font-bolder color-gray-10",
    },
    [
      _vm._v("\n  " + _vm._s(_vm.tip) + "\n  "),
      _c("br"),
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.$t("pc_biz_multi_class_tip2" /* 请您确认是否同意此次安排。*/)
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }